<template>
  <div class="content-wrapper">
    <div class="container">
      <v-row v-if="guia != null">
        <v-col>
          <div id="modalPrint">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">Cotización de envío # <strong>{{ cotizacion.id }}</strong></h4>
                  <p></p>
                </div>
                <div class="modal-body" id="billdata">
                  <p></p>
                  <div class="row">
                    <div class="col-sm-6"><img src="images/logo.jpg" width="200" height="43"></div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6" style="font-size: 9px">
                      <div>
                        <h6 v-if="guia.tipoguia != 'importacion'" style="font-weight: bold;">Enviador: </h6>
                        <h6 v-else style="font-weight: bold;">Recogido desde: </h6>
                        <div id="s6"><label>País:</label> {{ guia.pais_e }}</div>
                        <div id="s7"><label>Ciudad:</label> {{ guia.ciudad_e }}</div>
                        <div id="s72"><label>Código Postal:</label> {{ guia.zip_e }}</div>
                      </div>
                    </div>
                    <div class="col-sm-6" style="font-size: 9px">
                      <h6 style="font-weight: bold;">Consignatario: </h6>
                      <div id="c6"><label>País:</label> {{ guia.pais_c }}</div>
                      <div id="c7"><label>Ciudad:</label> {{ guia.ciudad_c }}</div>
                      <div id="c7"><label>Código Postal:</label> {{ guia.zip_c }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6" style="font-size: 9px">
                      <h6 style="font-weight: bold;">Detalles del envío:</h6>
                      <div><label>Número de piezas:</label><span> {{ guia.piezas }}</span></div>
                      <div><label>Peso Total: </label><span> {{ guia.paquetes[0].peso == null ?
                        guia.peso :
                        guia.paquetes.reduce((sumP, item) => sumP + parseFloat(item.pesototal), 0) }} kgs</span></div>
                      <div><label>Peso Dimensional: </label><span> {{ guia.volumen }} kgs</span></div>
                    </div>
                    <div class="col-sm-6" style="font-size: 9px">
                      <h6 style="color: white;">.</h6>
                      <div><label>Valor declarado: </label><span> {{ guia.valor }} {{ guia.moneda }}</span></div>
                      <div><label>Tipo de producto: </label><span> {{ guia.tipo }}</span></div>
                      <div><label>Peso Cotizado: </label><span> {{ guia.peso_cobrar }} kgs</span></div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12" style="font-size: 9px">
                      <h6 style="color: black;">Cotización</h6>
                      <div v-if="status == true">
                        <table class="table" style="font-size: 10px">
                          <thead>
                            <th>Descripción</th>
                            <th style="text-align: right">
                              Valor
                            </th>
                            <th style="text-align: right">Taxes</th>
                            <th style="text-align: right">SubTotal</th>
                          </thead>
                          <tbody v-if="Array.isArray(cotizacion.extracargos.QtdShpExChrg)">
                            <!--Flete-->
                            <tr>
                              <td>Flete</td>
                              <td style="text-align: right">${{ cotizacion.flete }}</td>
                              <td style="text-align: right">
                                ${{ Math.round((cotizacion.flete * cotizacion.iva) * 100) / 100 }}
                              </td>
                              <td style="text-align: right">
                                ${{ Math.round((cotizacion.flete + (cotizacion.flete * cotizacion.iva)) * 100) / 100 }}
                              </td>
                            </tr>
                            <!--Descuento-->
                            <!--tr v-if="cotizacion.descuento != null">
                              <td>Descuento ({{ cotizacion.descuento.codigo }})</td>
                              <td style="text-align: right"></td>
                              <td style="text-align: right"></td>
                              <td style="text-align: right; color: red;">
                                -${{ Math.round(((((cotizacion.flete + (cotizacion.flete * cotizacion.iva))) *
                                  (cotizacion.descuento.porc_descuento/100))) * 100) / 100 }}
                              </td>
                            </tr-->
                            <!--Extracargos-->

                            <tr
                              v-for="extrac in cotizacion.extracargos.QtdShpExChrg.filter((ec) => ec.SpecialServiceType != 'II')"
                              :key="extrac.SpecialServiceType">
                              <td>{{ typeof(cotizacion.extracargos.QtdShpExChrg.GlobalServiceName) == 'object' ? 'Demand Surcharge' : extrac.GlobalServiceName }}</td>
                              <td style="text-align: right">${{ Math.round((parseFloat(extrac.ChargeValue) -
                                parseFloat(extrac.ChargeTaxAmount)) * 100) / 100 }}</td>
                              <td style="text-align: right">
                                ${{ extrac.ChargeTaxAmount }}
                              </td>
                              <td style="text-align: right">
                                ${{ extrac.ChargeValue }}
                              </td>
                            </tr>

                            <!--Tramite para import-->
                            <tr v-if="guia.tipoguia == 'importacion'">
                              <td>
                                <div>{{ cotizacion.corteGuia > 0 ? 'Corte de Guia' : 'Trámite' }}</div>
                              </td>
                              <td style="text-align: right">${{ Math.round((cotizacion.corteGuia > 0 ? cotizacion.corteGuia
                                :cotizacion.tramite) *100) /100}}</td>
                              <td style="text-align: right">
                                ${{ Math.round(((cotizacion.corteGuia > 0 ? cotizacion.corteGuia : cotizacion.tramite) *
                                cotizacion.iva) * 100) / 100 }}
                              </td>
                              <td style="text-align: right">
                                ${{ Math.round(((cotizacion.corteGuia > 0 ? cotizacion.corteGuia : cotizacion.tramite) +
                                  ((cotizacion.corteGuia > 0 ? cotizacion.corteGuia : cotizacion.tramite) *
                                cotizacion.iva)) * 100) / 100 }}
                              </td>
                            </tr>

                            <!--Seguro-->
                            <tr v-if="cotizacion.seguro > 0">
                              <td>Seguro</td>
                              <td style="text-align: right">${{ cotizacion.seguro }}</td>
                              <td style="text-align: right">
                                ${{ Math.round((cotizacion.seguro * cotizacion.iva) * 100) / 100 }}
                              </td>
                              <td style="text-align: right">
                                ${{ Math.round((cotizacion.seguro + (cotizacion.seguro * cotizacion.iva)) * 100) / 100
                                }}
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <!--Flete-->
                            <tr>
                              <td>Flete</td>
                              <td style="text-align: right">${{ cotizacion.flete }}</td>
                              <td style="text-align: right">
                                ${{ Math.round((cotizacion.flete * cotizacion.iva) * 100) / 100 }}
                              </td>
                              <td style="text-align: right">
                                ${{ Math.round((cotizacion.flete + (cotizacion.flete * cotizacion.iva)) * 100) / 100 }}
                              </td>
                            </tr>
                            <!--Descuento-->
                            <!--tr v-if="cotizacion.descuento != null">
                              <td>Descuento ({{ cotizacion.descuento.codigo }})</td>
                              <td style="text-align: right"></td>
                              <td style="text-align: right"></td>
                              <td style="text-align: right; color: red;">
                                -${{ Math.round(((((cotizacion.flete + (cotizacion.flete * cotizacion.iva))) *
                                  (cotizacion.descuento.porc_descuento/100))) * 100) / 100 }}
                              </td>
                            </tr-->
                            <!--Extracargos-->
                            <tr>
                              <td>{{ typeof(cotizacion.extracargos.QtdShpExChrg.GlobalServiceName) == 'object' ? 'Demand Surcharge' : cotizacion.extracargos.QtdShpExChrg.GlobalServiceName }}</td>
                              <td style="text-align: right">${{
                              Math.round((parseFloat(cotizacion.extracargos.QtdShpExChrg.ChargeValue) -
                              parseFloat(cotizacion.extracargos.QtdShpExChrg.ChargeTaxAmount)) * 100) / 100
                               }}</td>
                              <td style="text-align: right">
                                ${{ cotizacion.extracargos.QtdShpExChrg.ChargeTaxAmount }}
                              </td>
                              <td style="text-align: right">
                                ${{ cotizacion.extracargos.QtdShpExChrg.ChargeValue }}
                              </td>
                            </tr>
                            <!--Tramite para import-->
                            <tr v-if="guia.tipoguia == 'importacion'">
                              <td>{{ cotizacion.corteGuia > 0 ? 'Corte de Guia' : 'Trámite' }}</td>
                              <td style="text-align: right">${{ Math.round((cotizacion.corteGuia > 0 ? cotizacion.corteGuia
                                :cotizacion.tramite)*100)/100}}</td>
                              <td style="text-align: right">
                                ${{ Math.round(((cotizacion.corteGuia > 0 ? cotizacion.corteGuia : cotizacion.tramite) *
                                cotizacion.iva) * 100) / 100 }}
                              </td>
                              <td style="text-align: right">
                                ${{ Math.round(((cotizacion.corteGuia > 0 ? cotizacion.corteGuia : cotizacion.tramite) +
                                  ((cotizacion.corteGuia > 0 ? cotizacion.corteGuia : cotizacion.tramite) *
                                cotizacion.iva)) * 100) / 100 }}
                              </td>
                            </tr>
                            <!--Seguro-->
                            <tr v-if="cotizacion.seguro > 0">
                              <td>Seguro</td>
                              <td style="text-align: right">${{ cotizacion.seguro }}</td>
                              <td style="text-align: right">
                                ${{ Math.round((cotizacion.seguro * cotizacion.iva) * 100) / 100 }}
                              </td>
                              <td style="text-align: right">
                                ${{ Math.round((cotizacion.seguro + (cotizacion.seguro * cotizacion.iva)) * 100) / 100
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="d-flex justify-end">
                          <h6>Total Servicio: ${{ totalPagar }}</h6>
                        </div>
                        <div class="row" v-if="cotizacion.corteGuia > 0">
                          <div class="col-sm-12">
                            <span style="color: blue;font-size: x-small;">*** En caso de requerir los servicios de Nacionalizacion con con nuestro Agente de Aduana consultar con su ejecutivo de venta los valores</span>
                          </div>
                        </div>
                        <div class="row dense">
                          <div class="col-sm-12">
                            <span style="color: blue;font-size: x-small;">*** Segun el tipo de Producto pueden existir extracargos adicionales, Consultar con su ejecutivo de ventas.</span> <br />
                            <span style="color: blue;font-size: x-small;">*** Fuel surcharge puede variar semanalmente</span><br />
                            <span style="color: blue;font-size: x-small;">*** En zonas remotas existen extracargos, esto se lo determina por el código postal.</span><br />
                            <span style="color: blue;font-size: x-small;">*** En algunos países se puede generar Declaración de Exportación el valor aprox es de $190 más IVA.</span><br />
                            <span style="color: blue;font-size: x-small;">*** Cotización para importación por la red, mercadería general y no peligrosa.</span><br />
                            <span style="color: blue;font-size: x-small;">*** Para el caso de las importaciones considerar que el valor del tramite de aduana puede variar segun la fecha de salida del paquete, el mismo tiene un cargo adicional de Almacenaje de USD 3 x cada dia a partir del 3er dia luego del arribo.</span><br />
                            <span style="color: blue;font-size: x-small;">*** Esta cotización  puede variar pues está  sujeta a la verificación del peso  y volumen recibido.</span><br />
                            <span style="color: blue;font-size: x-small;">*** El peso volumen se obtiene de las medidas en centímetros de Largo x alto x ancho divido para 5000.</span><br />
                            <span style="color: blue;font-size: x-small;">*** cualquier inquietud consultar con su ejecutiva.</span><br />
                          </div>
                        </div>
                        <br />
                        <br />
                        <hr />
                        <div class="row dense">
                          <div class="col-sm-12">
                            <span style="color: grey;font-size: xx-small;">IN EXPRESS-COURIER S.A., en su calidad de Responsable de tratamiento de datos personales, informa que trata la información personal proporcionada con la finalidad de atender sus consultas y emitir las cotizaciones requeridas.
                              La información será almacenada por el tiempo necesario para cumplir con las finalidades señaladas o hasta que usted retire su consentimiento para su tratamiento.
                              Para el ejercicio de sus derechos respecto a sus datos personales, puede presentar una solicitud a través del correo: datos.proteccion@inexpress.com.ec

                              Para más información sobre el tratamiento de sus datos, consulta nuestra Política de Privacidad, disponible en nuestra página web.</span>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <h6 style="color: red;">No se pudo generar la cotizacion</h6>
                        <br />
                        <h5 style="color: red;">{{ mensaje }}</h5>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12"></div>
                  </div>
                </div>
                <hr class="border">
                <div class="modal-footer">
                  <v-btn color="blue" @click="imprimirGuia()" outlined>Imprimir</v-btn>
                  <p></p>
                </div>
              </div>
              <p></p>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import apicon from '../plugins/apicon';
import utils from '../utils/utils';
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
    dataGuia: {
      type: Object,
      default: null,
    },
  },
  components: {

  },
  created: function () { },
  data() {
    return {
      cotizacion: null,
      guia: null,
      isCliente: 1,
      formatedDate: null,
      subTotalExtraCargos: 0,
      subTotalDescuento: 0,
      totalPagar: 0,
      status: true,
      mensaje: "",
    };
  },
  methods: {
    fillDatosGuia: async function () {
      if (this.id != null && this.dataGuia == null) {
        await apicon.getDataApi(apicon.getApiBaseUrl() + 'obtenercotizacion/' + this.id).then((result) => {
          this.cotizacion = result.data;
          this.guia = result.data.guia;
          this.status = result.status;
          this.mensaje = result.message;
        });
      } else {
        this.cotizacion = this.dataGuia.data;
        this.guia = this.dataGuia.data.guia;
        this.status = this.dataGuia.status;
        this.mensaje = this.dataGuia.message;
      }

      this.subTotalDescuento = this.cotizacion.descuento != null ? (Math.round(((((this.cotizacion.flete)) * (this.cotizacion.descuento.porc_descuento / 100))) * 100) / 100) : 0;
      this.subTotalDescuento = Math.round(this.subTotalDescuento * 100) / 100;
      this.cotizacion.flete = Math.round((this.cotizacion.flete - this.subTotalDescuento) * 100) / 100;

      if (Array.isArray(this.cotizacion.extracargos.QtdShpExChrg)) {
        //Mapear el adicional
        this.cotizacion.extracargos.QtdShpExChrg = this.cotizacion.extracargos.QtdShpExChrg.map((ec) => {
          if(ec.SpecialServiceType == "FF"){
            ec.ChargeValue = Math.round(((parseFloat(this.cotizacion.flete) * parseFloat(this.cotizacion.porcFS)) +  ((parseFloat(this.cotizacion.flete) * parseFloat(this.cotizacion.porcFS)) * parseFloat(this.cotizacion.iva)))* 100) / 100;
            ec.ChargeTaxAmount = Math.round((parseFloat(ec.ChargeValue) - (parseFloat(ec.ChargeValue) / (1 + parseFloat(this.cotizacion.iva)))) * 100) / 100;
          }else{
            ec.ChargeValue = Math.round((parseFloat(ec.ChargeValue) + (parseFloat(this.cotizacion.porcExtracargos) * parseFloat(ec.ChargeValue))) * 100) / 100;
            ec.ChargeTaxAmount = Math.round((parseFloat(ec.ChargeValue) - (parseFloat(ec.ChargeValue) / (1 + parseFloat(this.cotizacion.iva)))) * 100) / 100;
          }
          return ec;
        })
        this.subTotalExtraCargos = this.cotizacion.extracargos.QtdShpExChrg.filter((ec) => ec.SpecialServiceType != 'II').reduce((pv, cv) => pv + (parseFloat(cv.ChargeValue)), 0);
      } else if (typeof this.cotizacion.extracargos.QtdShpExChrg === 'object' && this.cotizacion.extracargos.QtdShpExChrg != null) {//Si es solo uno es el FF
        if(this.cotizacion.extracargos.QtdShpExChrg.SpecialServiceType == "FF"){
          this.cotizacion.extracargos.QtdShpExChrg.ChargeValue = Math.round(((parseFloat(this.cotizacion.flete) * parseFloat(this.cotizacion.porcFS)) +  ((parseFloat(this.cotizacion.flete) * parseFloat(this.cotizacion.porcFS)) * parseFloat(this.cotizacion.iva)))* 100) / 100;
          console.log(this.cotizacion.extracargos.QtdShpExChrg.ChargeValue);
          this.cotizacion.extracargos.QtdShpExChrg.ChargeTaxAmount = Math.round((parseFloat(this.cotizacion.extracargos.QtdShpExChrg.ChargeValue) - (parseFloat(this.cotizacion.extracargos.QtdShpExChrg.ChargeValue) / (1 + parseFloat(this.cotizacion.iva)))) * 100) / 100;
        }
        this.subTotalExtraCargos = (parseFloat(this.cotizacion.extracargos.QtdShpExChrg.ChargeValue));
      }
      this.subTotalExtraCargos = Math.round(this.subTotalExtraCargos * 100) / 100;

      this.totalPagar = Math.round((parseFloat(this.cotizacion.flete) +
        (parseFloat(this.cotizacion.flete) * parseFloat(this.cotizacion.iva)) +
        parseFloat(this.cotizacion.tramite) +
        (parseFloat(this.cotizacion.tramite) * parseFloat(this.cotizacion.iva)) +
        parseFloat(this.cotizacion.corteGuia) +
        (parseFloat(this.cotizacion.corteGuia) * parseFloat(this.cotizacion.iva)) +
        parseFloat(this.cotizacion.seguro +
        (parseFloat(this.cotizacion.seguro) * parseFloat(this.cotizacion.iva))) +
        this.subTotalExtraCargos) * 100) / 100;
    },
    imprimirGuia: function () {
      var mywindow = window.open('', 'tracking div', 'height=400,width=600');
      mywindow.document.write('<html><head><link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css"><link rel="stylesheet" href="css/print.css" media="print" /><link rel="stylesheet" href="css/bootstrap-print.min.css" media="print"/></head><body onload="window.print()">');
      mywindow.document.write('<div>' + $("#billdata").html() + '</div>');
      mywindow.document.write('</body></html>');
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10
      setTimeout(function () { mywindow.close(); }, 1000);
    },
  },
  mounted: async function () {
    apicon.setAuthHeaders();
    this.isCliente = localStorage.getItem('cliente');
    await this.fillDatosGuia();
    this.formatedDate = utils.formatDate(this.guia.created_at);
  },
};
</script>
<style scoped src="bootstrap/dist/css/bootstrap.css"></style>
